import { type PropsWithChildren, useMemo } from 'react';

import { REPUBS } from '@cx-modules/constants';

import FooterNav from '~/components/FooterNav';
import FooterOC from '~/components/FooterOC';
import FooterUsStyle from '~/components/FooterUsStyle';
import FooterV2 from '~/components/FooterV2';
import Header from '~/components/Header';
import HeaderV2 from '~/components/HeaderV2';
import MobileBottomNav from '~/components/MobileBottomNav';
import { useLayoutStore } from '~/providers/layout-store-provider';
import { shouldUseHeaderFooterV2 } from '~/utils/shouldUseHeaderFooterV2';

interface V2SelectorProps {
	shouldUseV2: boolean;
}

const SelectHeader = ({ shouldUseV2 }: V2SelectorProps) => {
	const deviceType = useLayoutStore(s => s.deviceType);
	const navData = useLayoutStore(s => s.navData);
	const repub = useLayoutStore(s => s.repub);
	const resourcesUrl = useLayoutStore(s => s.resourcesUrl);

	if (!shouldUseV2) {
		return (
			<Header
				deviceType={deviceType}
				navData={navData as any}
				repub={repub}
				resourcesUrl={resourcesUrl}
			/>
		);
	}

	return <HeaderV2 />;
};

const SelectFooter = ({ shouldUseV2 }: V2SelectorProps) => {
	const deviceType = useLayoutStore(s => s.deviceType);
	const navData = useLayoutStore(s => s.navData);
	const repub = useLayoutStore(s => s.repub);
	const resourcesUrl = useLayoutStore(s => s.resourcesUrl);
	const footerData = useLayoutStore(s => s.footerData);

	if (!shouldUseV2) {
		const castedFooterData = footerData as any;
		return (
			<footer id="mainAppFooter">
				<FooterNav
					categoryLinks={castedFooterData.categoryLinks}
					deviceType={deviceType}
					repub={repub}
				/>
				{repub === REPUBS.OC.name ? (
					<FooterOC />
				) : (
					<FooterUsStyle
						generalLinks={castedFooterData.generalLinks}
						repub={repub}
						resourcesUrl={resourcesUrl}
						socialLinks={castedFooterData.socialLinks}
					/>
				)}
			</footer>
		);
	}

	return (
		<>
			<FooterV2 />
			<MobileBottomNav
				mobileBottomNavData={navData.mobileBottomNav}
				repub={repub}
			/>
		</>
	);
};

export const LayoutComponents = ({ children }: PropsWithChildren) => {
	const repub = useLayoutStore(s => s.repub);

	const shouldUseV2 = useMemo(() => shouldUseHeaderFooterV2(repub), [repub]);

	return (
		<>
			<SelectHeader shouldUseV2={shouldUseV2} />
			{children}
			<SelectFooter shouldUseV2={shouldUseV2} />
		</>
	);
};
